import {Consts} from "../pages/consts";
import SearchDrug from "./SearchDrug";
import AddFreeTextDrugDetails from "./AddFreeTextDrugDetails";
import {useState} from "react";
import {useTranslation} from "react-i18next";

const SpecifyNewDrug = ({patDrugs, allProductNames, allSubstances, onSetSelectedDrug, resetFields, setMessageText,
                          setStrength, setStrengthUnit, handleSetFreeDrugDetails, init = false, language}) => {
  const { t } = useTranslation();
  const [searchOrFree, setSearchOrFree] = useState(Consts.SEARCH);

  return (
    <div className="add-drug-mode-card">
      <div className="add-drug-mode-header">
        <div className="add-drug-tabs" role="tablist" aria-label={t("search_by")}>
          <button
            type="button"
            role="tab"
            aria-selected={searchOrFree === Consts.SEARCH}
            className={`add-drug-tab ${searchOrFree === Consts.SEARCH ? "is-active" : ""}`}
            onClick={() => setSearchOrFree(Consts.SEARCH)}
          >
            {t("search_in_list_tab")}
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={searchOrFree === Consts.FREE_TEXT}
            className={`add-drug-tab ${searchOrFree === Consts.FREE_TEXT ? "is-active" : ""}`}
            onClick={() => setSearchOrFree(Consts.FREE_TEXT)}
          >
            {t("manual_entry_tab")}
          </button>
        </div>
      </div>
      <div className="add-drug-mode-body">
        { searchOrFree === Consts.SEARCH &&
          <SearchDrug
            patDrugs={ patDrugs }
            allProductNames={ allProductNames }
            allSubstances={ allSubstances }
            onSetDrug={ onSetSelectedDrug }
            onResetFields={ resetFields }
            onSetMessageText={ setMessageText }
            onSetStrength={ setStrength }
            onSetStrengthUnit={ setStrengthUnit }
            language={language}
          />
        }
        { searchOrFree === Consts.FREE_TEXT &&
          <AddFreeTextDrugDetails onHandleSetFreeDrugDetails={handleSetFreeDrugDetails}/>
        }
      </div>
    </div>
  );
}

export default SpecifyNewDrug;